import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ user }) => {
  return <>{!user ? <Navigate to="/login" replace /> : <Outlet />}</>;
};

export default ProtectedRoute;
